import { useQuery } from '@tanstack/react-query';
import { curatorQueries } from '../../query-factory';

interface UseLikedSnapsCountQueryOptions {
  enabled?: boolean;
}

export const useLikedSnapsCountQuery = (
  snapIds: string[],
  { enabled = true }: UseLikedSnapsCountQueryOptions = {},
) =>
  useQuery({
    ...curatorQueries['snap-like'].likedCount(snapIds),
    enabled: enabled && snapIds.length > 0,
  });
